<template>
    <div>
      <modal name="eliminar-modal" :width="550" :height="'auto'" :clickToClose="false">
        <div class="modal-content">
          <!-- <span class="closebtn" @click="closeModal">&times;</span> -->
          <!-- <i class="fa-solid fa-exclamation fa-5x" style="color: #ffffff; size: 5rem;"></i> -->
          <i class="fas fa-exclamation-circle fa-5x" style="color: #ffffff; size: 5rem;"></i>
          <!-- <i class="fas fa-exclamation-circle fa-5x" style="color: #ffffff; size: 5rem;"></i> -->
        </div>
        <div class="text-center p-3 mb-2">
            <strong style="font-size: 23px; color: #4d4d4d;">¿Esta seguro de {{ accion }} el usuario {{ usuario }}?</strong> 
        </div>
        <div class="row text-center pb-4 justify-content-center">
            <div class="col-md-4 text-center">
                <button class="btn btn-danger col-12" @click="closeModal">Cancelar</button>
            </div>
            <div class="col-md-4 text-center">
                <button class="btn btn-success col-12" @click="changeUser">{{ capitalizedAccion }}</button>
            </div>
            </div>
      </modal>
    </div>
  </template>
  
  <script>
  export default {
    name: 'App',
    props: {
        changeUser: Function,
        accion: String,
        usuario: String,
    },
    data() {
      return {
        // accionButton: accion,
        // usuario: 'Admin01',
      };
    },
    computed: {
        capitalizedAccion() {
            return this.accion.charAt(0).toUpperCase() + this.accion.slice(1);
        }
    },
    methods: {
      closeModal() {
        this.$modal.hide('eliminar-modal');
      }
    }
  };
  </script>
  
  <style scoped>
  .modal-content {
    padding: 15px;
    background-color: #f4c836ea; /* Red */
    color: white;
    border-top-left-radius: 15px; /* Rounded top-left corner */
    border-top-right-radius: 15px; /* Rounded top-right corner */
    position: relative; /* For positioning the close button */
    text-align: center; /* Center the text */
    border-color: #f4c836ea;;
  }
  
  .closebtn {
    position: absolute;
    top: 10px;
    right: 15px;
    color: white;
    font-weight: bold;
    font-size: 22px;
    line-height: 20px;
    cursor: pointer;
    transition: 0.3s;
  }
  
  .closebtn:hover {
    color: rgb(214, 212, 212);
  }
  </style>
  